/**
 * Picks the shell by viewport: `PhoneLayout` below `md`, `Layout` otherwise
 * (ROADMAP "The phone branch", D5). One switch for every route, so a phone
 * never gets the desktop drawer around anything. The sign-in dialog is mounted
 * here, once, so signing in works in either shell.
 */
import React from 'react';
import Layout from './Layout';
import PhoneLayout from './PhoneLayout';
import { usePhoneViewport } from './phone/usePhoneViewport';
import SignInDialog from './components/auth/SignInDialog';
import { useGoogleOneTap } from './auth/useGoogleOneTap';

const ResponsiveLayout: React.FC = () => {
  // Google One Tap for signed-out readers, once per visit (ROADMAP 1.37).
  useGoogleOneTap();
  const isPhone = usePhoneViewport();
  return (
    <>
      {isPhone ? <PhoneLayout /> : <Layout />}
      {/* One sign-in dialog for both shells — opened from anywhere via LoginDialogContext. */}
      <SignInDialog />
    </>
  );
};

export default ResponsiveLayout;
